/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MerkleRedeemUpgradeSafe } from "./MerkleRedeemUpgradeSafe";

export class MerkleRedeemUpgradeSafeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<MerkleRedeemUpgradeSafe> {
    return super.deploy(overrides || {}) as Promise<MerkleRedeemUpgradeSafe>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MerkleRedeemUpgradeSafe {
    return super.attach(address) as MerkleRedeemUpgradeSafe;
  }
  connect(signer: Signer): MerkleRedeemUpgradeSafeFactory {
    return super.connect(signer) as MerkleRedeemUpgradeSafeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MerkleRedeemUpgradeSafe {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as MerkleRedeemUpgradeSafe;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_claimant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_balance",
        type: "uint256",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityProvider",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_begin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_end",
        type: "uint256",
      },
    ],
    name: "claimStatus",
    outputs: [
      {
        internalType: "bool[]",
        name: "",
        type: "bool[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityProvider",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_week",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_claimedBalance",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "_merkleProof",
        type: "bytes32[]",
      },
    ],
    name: "claimWeek",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityProvider",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "week",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "balance",
            type: "uint256",
          },
          {
            internalType: "bytes32[]",
            name: "merkleProof",
            type: "bytes32[]",
          },
        ],
        internalType: "struct MerkleRedeemUpgradeSafe.Claim[]",
        name: "claims",
        type: "tuple[]",
      },
    ],
    name: "claimWeeks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "claimed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_begin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_end",
        type: "uint256",
      },
    ],
    name: "merkleRoots",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_week",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "_merkleRoot",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_totalAllocation",
        type: "uint256",
      },
    ],
    name: "seedAllocations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityProvider",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_week",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_claimedBalance",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "_merkleProof",
        type: "bytes32[]",
      },
    ],
    name: "verifyClaim",
    outputs: [
      {
        internalType: "bool",
        name: "valid",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "weekMerkleRoots",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
